import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { exportToCSV, exportToExcel, exportToPDF, printPage } from './exportUtils';
import './Products.css';
import './ProductsActions.css';
import './MobileResponsive.css';

const PurchaseRequisition = () => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState('');
  const [showFilters, setShowFilters] = useState(false);
  const [showExportDropdown, setShowExportDropdown] = useState(false);
  const [perPage, setPerPage] = useState(25);

  const handleExport = (format) => {
    // This component currently shows "No data available" hardcoded
    // but we wire it up assuming a 'data' array for future-proofing
    const data = []; 

    if (data.length === 0) {
      alert('No data available to export');
      setShowExportDropdown(false);
      return;
    }

    const headers = ['Requisition No', 'Date', 'Requested By', 'Location', 'Status', 'Total'];
    const rows = data.map(r => [
      r.requisitionNo || '',
      r.date || '',
      r.requestedBy || '',
      r.location || '',
      r.status || '',
      r.total || '0.00'
    ]);

    const title = 'Purchase Requisitions';
    const filename = 'purchase_requisitions';

    if (format === 'CSV') exportToCSV(headers, rows, filename);
    else if (format === 'Excel') exportToExcel(headers, rows, filename);
    else if (format === 'PDF') exportToPDF(title, headers, rows, filename);
    else if (format === 'Print') printPage();

    setShowExportDropdown(false);
  };

  const handlePrint = () => { printPage(); setShowExportDropdown(false); };
  const handleColumnVisibility = () => { alert('Column visibility'); setShowExportDropdown(false); };

  return (
    <div className="products-container">
      <div className="main-card">
        <div className="product-tabs">
          <div className="product-tab active"><i className="fa fa-file-text"></i> Purchase Requisition</div>
        </div>
        <div className="table-controls">
          <div className="table-controls-left">
            <div className="entries-dropdown">
              <span>Show</span>
              <select value={perPage} onChange={(e) => setPerPage(Number(e.target.value))}>
                <option value={25}>25</option><option value={50}>50</option><option value={100}>100</option>
              </select>
              <span>entries</span>
            </div>
          </div>
          <div className="table-controls-right">
            <div className="tabs-search-wrapper">
              <input type="text" placeholder="Search..." value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)}
                className="tabs-search-input" />
              <button className="filter-toggle-btn" onClick={() => setShowFilters(true)}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M10 18h4v-2h-4v2zM3 6v2h18V6H3zm3 7h12v-2H6v2z" /></svg>
                Filters
              </button>
            </div>
            <div className="export-dropdown-container" style={{ position: 'relative' }}>
              <button className="export-btn" onClick={() => setShowExportDropdown(!showExportDropdown)}>
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path><polyline points="7 10 12 15 17 10"></polyline><line x1="12" y1="15" x2="12" y2="3"></line></svg>
                Export ▾
              </button>
              {showExportDropdown && (
                <div className="export-dropdown-menu">
                  <button onClick={() => handleExport('CSV')}><i className="fa fa-file-csv"></i> Export CSV</button>
                  <button onClick={() => handleExport('Excel')}><i className="fa fa-file-excel"></i> Export Excel</button>
                  <button onClick={() => handleExport('Print')}><i className="fa fa-print"></i> Print</button>
                  <button onClick={() => handleExport('PDF')}><i className="fa fa-file-pdf"></i> Export PDF</button>
                </div>
              )}
            </div>
            <button className="control-btn-primary" onClick={() => navigate('/purchases/requisition/add')}>
              <span className="plus-icon">+</span> Add
            </button>
          </div>
        </div>
        <div className="table-content-card">
          <div className="products-table-container">
            <table className="products-table">
              <thead>
                <tr>
                  <th>Action</th>
                  <th>Requisition No</th>
                  <th>Date</th>
                  <th>Requested By</th>
                  <th>Location</th>
                  <th>Status</th>
                  <th>Total</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td colSpan="7" style={{ textAlign: 'center', padding: '2rem' }}>
                    No purchase requisitions found.
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PurchaseRequisition;
